<svelte:head>
    <title>The Phoenix Pages - Logout</title>
</svelte:head>

<script>
	import { onMount } from 'svelte';

    onMount(async () => {
        window.localStorage.removeItem('refresh_token', '');
        window.localStorage.removeItem('user', '');
        window.localStorage.removeItem('player', '');

        // Redirect to Homepage

        window.location = '/';
    });
</script>